<template>
    <div class="full-height">
        <div class="table-responsive custom-block">
            <table v-if="trips.length > 0" class="table w-100 table-border">
                <thead>
                <tr>
                    <th scope="col">{{i18n('Departure')}}</th>
                    <th scope="col">{{i18n('Arrival')}}</th>
                    <th scope="col">{{i18n('Name trip')}}</th>
                    <th scope="col">{{i18n('Count empty seats')}}</th>
                    <th scope="col">{{i18n('Rate (summa)')}}</th>
                    <th scope="col">{{i18n('Bus')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr class="no-border">
                    <td colspan="7"></td>
                </tr>
                <tr v-for="trip in trips" :class="{'checked': trip.id === selectedTrip.id}" @click="selectTrip(trip)">
                    <td>
                        <div class="d-flex flex-column justify-content-center">
                            {{trip.departure_at | moment('HH:mm')}}
                            <span class="text-muted text-small">{{trip.departure_at | moment('YYYY-MM-DD')}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex flex-column justify-content-center">
                            {{trip.arrive_at | moment('HH:mm')}}
                            <span class="text-muted text-small">{{trip.arrive_at | moment('YYYY-MM-DD')}}</span>
                        </div>
                    </td>
                    <td>{{trip.name}}</td>
                    <td>{{trip.seats - trip.sold_seats}}</td>
                    <td>
                        <div class="d-flex flex-column justify-content-center">
                            {{trip.price}}
                            <span class="text-muted text-small">{{trip.tariff_name}}</span>
                        </div>
                    </td>
                    <td>{{trip.bus_model_name}}</td>
                </tr>
                </tbody>
            </table>
            <div v-if="loadingState" class="d-flex justify-content-center align-items-center">
                <i class="loading-spinner"></i>{{ i18n("Loading") }}
            </div>
            <div v-if="!loadingState && trips.length === 0" style="text-align: center;margin-top: 20px;">{{ i18n("The bus does not go on the indicated date") }}</div>
        </div>
        <div class="middle-box"></div>
        <div class="bottom-box">
            <div class="row">
                <div class="offset-sm-8 col-sm-4">
                    <button class="btn float-right w-100 btn-primary"
                            v-if="trips.length > 0"
                            :disabled="!selectedTrip.id"
                            @click="next()">
                        {{i18n('Next')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'trips-list',
        props: {
            trips: {
                type: Array,
                required: true,
            },
            selectedTrip: {},
            loadingState: true,
        },
        methods: {
            selectTrip(trip) {
                this.$emit('selectTrip', trip);
            },
            next() {
                this.$emit('next');
            }
        }
    }
</script>

<style scoped>
    .text-small {
        font-size: 15px !important;
    }

    .checked .text-small {
        color: #FFFFFF !important;
    }

    .table tbody td, .table tbody th {
        padding: 15px;
    }

    .custom-block {
        height: 450px;
        overflow-y: scroll;
    }
    @-webkit-keyframes rotate-forever {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-moz-keyframes rotate-forever {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes rotate-forever {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .loading-spinner {
        -webkit-animation-duration: 0.75s;
        -moz-animation-duration: 0.75s;
        animation-duration: 0.75s;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        -webkit-animation-name: rotate-forever;
        -moz-animation-name: rotate-forever;
        animation-name: rotate-forever;
        -webkit-animation-timing-function: linear;
        -moz-animation-timing-function: linear;
        animation-timing-function: linear;
        height: 30px;
        width: 30px;
        border: 3px solid #000000;
        border-right-color: transparent;
        border-radius: 50%;
        display: inline-block;
        margin-right: 10px;
    }
</style>
